// extracted by mini-css-extract-plugin
module.exports = {"box":"box-7gJcHQYR","footer":"footer-2B8gpy0b"};